import KeenSlider from 'keen-slider';
import 'keen-slider/keen-slider.min.css';

// for the slider inside the prefooter block
document.addEventListener('DOMContentLoaded', function () {
  class BlockHotelsPush extends HTMLElement {
    constructor() {
      super();
      // elements
      this.keenSliders = [];
      this.sliders = this.querySelectorAll('.keen-slider');
      this.countrySelector = '.js-hotels-push__country';
      this.townsSelector = '.js-hotels-push__filters-town';
      this.prevSelector = '.js-hotels-push__prev';
      this.nextSelector = '.js-hotels-push__next';
      this.popinTrigger = '.js-hotels-push__trigger';
      this.countryFilterSelector = '.js-hotels-push__filter';
      this.townFilterSelector = '.js-hotels-push__filter-town';
    }
    connectedCallback() {
      // bindings
      this.bndHandleClick = this.handleClick.bind(this);
      // events
      this.onLoad();
      this.addEventListener('click', this.bndHandleClick);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.bndHandleClick);
      this.keenSliders.forEach(slider => {
        if (slider.destroy) slider.destroy();
      });
    }
    onLoad() {
      this.sliders.forEach((slider, index) => this.initSlider(slider, index));
    }
    handleClick(event) {
      const countryTrigger = event.target.closest(this.countryFilterSelector);
      if (countryTrigger) this.switchCountry(event, countryTrigger);
      const popinTrigger = event.target.closest(this.popinTrigger);
      if (popinTrigger) this.openPopin(event, popinTrigger);
      const townTrigger = event.target.closest(this.townFilterSelector);
      if (townTrigger) this.switchTown(event, townTrigger);
    }
    switchCountry(event, trigger) {
      event.preventDefault();
      const triggers = this.querySelectorAll(this.countryFilterSelector);
      triggers.forEach(t => t.removeAttribute('aria-current'));
      trigger.setAttribute('aria-current', 'true');
      const countries = this.querySelectorAll(this.countrySelector);
      countries.forEach(c => c.setAttribute('hidden', ''));
      const towns = this.querySelectorAll(this.townsSelector);
      towns.forEach(t => t.setAttribute('hidden', ''));
      const filters = this.querySelectorAll(this.townFilterSelector);
      filters?.forEach(f => f.removeAttribute('aria-current'));
      const target = trigger.getAttribute('href');
      const hash = target.split('#')[1];
      this.querySelector(`#${hash}`).removeAttribute('hidden');
      this.querySelector(`[data-id=${hash}]`).removeAttribute('hidden');
      this.keenSliders.forEach(slider => {
        slider?.update();
        slider?.slides?.forEach(s => s.removeAttribute('data-current'));
      });
    }
    switchTown(event, trigger) {
      const target = trigger.getAttribute('data-target');
      if (!target) return;
      const currentCountry = this.querySelector(`${this.countrySelector}:not([hidden])`);
      const currentSliderIndex = parseInt(currentCountry.getAttribute('data-index'), 10) ?? 0;
      const currentSlider = this.keenSliders[currentSliderIndex];
      if (!currentSlider) return;
      const slides = currentSlider?.slides;
      slides?.forEach(slide => {
        if (slide.getAttribute('data-town') !== target) {
          slide.setAttribute('data-current', 'false');
        } else {
          slide.setAttribute('data-current', 'true');
        }
      });
      const filters = this.querySelectorAll(this.townFilterSelector);
      filters?.forEach(filter => {
        if (filter.getAttribute('data-target') === target) {
          filter.setAttribute('aria-current', 'true');
        } else {
          filter.removeAttribute('aria-current');
        }
      });
      const targetSlideIndex = slides?.findIndex(slide => slide.getAttribute('data-town') === target);
      if (typeof targetSlideIndex !== 'number' || targetSlideIndex === -1) return;
      const maxIndex = currentSlider.track.details.maxIdx ?? 0;
      currentSlider.moveToIdx(targetSlideIndex > maxIndex ? maxIndex : targetSlideIndex);
    }
    openPopin(event, trigger) {
      event.preventDefault();
      const target = trigger.getAttribute('data-target');
      if (!target) return;
      const popin = document.querySelector(`#${target}`);
      if (!popin) return;
      popin?.handleOpen(event);
    }
    initSlider(el, index) {
      if (!el) return;
      const args = el.classList.contains('is-full') ? {
        slides: {
          perView: 1.15,
          spacing: 49
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2.85,
              spacing: 49
            }
          },
          '(min-width: 1200px)': {
            slides: {
              perView: 2.85,
              spacing: 61
            }
          }
        }
      } : {
        slides: {
          perView: 1.15,
          spacing: 2
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 3.15,
              spacing: 20
            }
          }
        }
      };
      this.keenSliders[index] = new KeenSlider(el, {
        ...args
      }, [slider => {
        const next = slider.container.closest(this.countrySelector)?.querySelector(this.nextSelector);
        const prev = slider.container.closest(this.countrySelector)?.querySelector(this.prevSelector);
        const refreshArrows = slider => {
          const details = slider.track.details;
          const current = details?.rel ?? 0;
          prev?.removeAttribute('disabled');
          next?.removeAttribute('disabled');
          if (current === 0) {
            prev?.setAttribute('disabled', 'disabled');
          }
          if (current >= details.maxIdx) {
            next?.setAttribute('disabled', 'disabled');
          }
        };
        slider.on('created', () => {
          slider.container?.classList.add('is-ready');
          refreshArrows(slider);
          prev?.addEventListener('click', () => {
            slider.prev();
          });
          next?.addEventListener('click', () => {
            slider.next();
          });
        });
        slider.on('slideChanged', () => {
          refreshArrows(slider);
        });
      }]);
    }
  }
  customElements.define('block-hotels-push', BlockHotelsPush);
});